import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const MembersTableSkeleton: React.FC = () => (
  <div className="space-y-3">
    <div className="flex items-center gap-3">
      <Skeleton className="h-9 w-64" />
      <Skeleton className="h-9 w-32" />
      <Skeleton className="h-9 w-28 ml-auto" />
    </div>
    <div className="rounded-md border border-border">
      {[0, 1, 2, 3, 4].map((i) => (
        <div key={i} className="flex items-center gap-4 px-3 py-2 border-b border-border last:border-b-0">
          <Skeleton className="h-4 w-4 rounded-sm" />
          <Skeleton className="h-8 w-8 rounded-full" />
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-7 w-28 rounded-md" />
          <div className="ml-auto flex gap-2">
            {[0, 1, 2, 3, 4, 5].map((j) => (
              <Skeleton key={j} className="h-6 w-16 rounded-full" />
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
)

export default MembersTableSkeleton
